(function () {
  var gallery = document.querySelector('[data-nr-gallery]');
  if (!gallery) return;

  var current = 0;

  var overlay = document.createElement('div');
  overlay.className = 'nr-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.innerHTML =
    '<button class="nr-lightbox__close" type="button" aria-label="Close">\u00d7</button>' +
    '<button class="nr-lightbox__nav nr-lightbox__nav--prev" type="button" aria-label="Previous">\u2039</button>' +
    '<img class="nr-lightbox__img" alt="">' +
    '<button class="nr-lightbox__nav nr-lightbox__nav--next" type="button" aria-label="Next">\u203a</button>';
  document.body.appendChild(overlay);

  var img = overlay.querySelector('.nr-lightbox__img');

  function getLinks() {
    return Array.from(gallery.querySelectorAll('[data-nr-gallery-full]')).sort(function (a, b) {
      var ai = parseInt(a.getAttribute('data-nr-gallery-index'), 10);
      var bi = parseInt(b.getAttribute('data-nr-gallery-index'), 10);
      if (isNaN(ai) || isNaN(bi)) return 0;
      return ai - bi;
    });
  }

  function show(index) {
    var links = getLinks();
    if (!links.length) return;
    current = (index + links.length) % links.length;
    img.src = links[current].getAttribute('data-nr-gallery-full');
  }

  function open(index) {
    show(index);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    img.removeAttribute('src');
  }

  gallery.addEventListener('click', function (event) {
    var link = event.target.closest('[data-nr-gallery-full]');
    if (!link || !gallery.contains(link)) return;

    event.preventDefault();
    var links = getLinks();
    var index = links.indexOf(link);
    if (index === -1) return;
    open(index);
  });

  overlay.addEventListener('click', function (event) {
    var target = event.target;
    if (target === overlay || target.classList.contains('nr-lightbox__close')) {
      close();
      return;
    }
    if (target.classList.contains('nr-lightbox__nav--prev')) {
      event.stopPropagation();
      show(current - 1);
    }
    if (target.classList.contains('nr-lightbox__nav--next')) {
      event.stopPropagation();
      show(current + 1);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!overlay.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') show(current - 1);
    if (event.key === 'ArrowRight') show(current + 1);
  });

  var wrap = document.querySelector('[data-nr-blog-gallery-wrap]');
  var loadMoreBtn = wrap && wrap.querySelector('[data-nr-blog-load-more]');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      wrap.classList.add('is-expanded');
    });
  }
})();
